<app-menu [isRenderMenu]="false" [menuModuleEnum]="menuModuleEnum"></app-menu>


<div class="container-body">
  <div class="vertical-aling-out">
    <div class="vertical-aling-inner">
      <div class="white-box">
        <h2>Redefinir senha</h2>
        <form class="form" [formGroup]="model"  (ngSubmit)="submit()">
          <p>Insira sua nova senha</p>
          <div class="row">
            <div class="col-md-12">
              <mat-form-field appearance="outline">
                <mat-label>Nova senha</mat-label>
                <mat-icon matSuffix (click)="hide = !hide">{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
                <input matInput [type]="hide ? 'password' : 'text'" formControlName="newPassword" required>
                @if (model.get('newPassword').invalid) {
                  <mat-error>Informe a nova senha</mat-error>
                }
              </mat-form-field>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <mat-form-field appearance="outline">
                <mat-label>Repetir senha</mat-label>
                <mat-icon matSuffix (click)="hideRepeat = !hideRepeat">{{hideRepeat ? 'visibility_off' : 'visibility'}}</mat-icon>
                <input matInput [type]="hideRepeat ? 'password' : 'text'" formControlName="repetedPassword" required>
                @if (model.get('repetedPassword').invalid) {
                  <mat-error>Informe a nova senha</mat-error>
                }
              </mat-form-field>
              <p [ngStyle]="{ 'color': model.get('newPassword').invalid ? '#fc0303' : '#000000' }">Use entre oito ou mais caracteres, com uma combinação de letras maiúsculas, letras minúsculas, números e caracteres especiais.</p>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <button mat-flat-button type="submit" color="primary" class=" btn-block">
                @if (isLoading == false) {
                  <span>Redefinir Senha</span>
                }
                @if (isLoading == true) {
                  <mat-spinner [diameter]="30" class="mat-spinner-btn"></mat-spinner>
                }
              </button>
              <button mat-flat-button type="button" routerLink="/" color="accent" class=" btn-block">
                Voltar
              </button>
            </div>
          </div>

        </form>
      </div>
    </div>
  </div>
</div>
